export const SectionDivider = ({ label }: { label: string }) => (
  <div className="flex items-center gap-3 pt-2">
    <span className="text-xs font-semibold uppercase tracking-wider text-muted-foreground whitespace-nowrap">
      {label}
    </span>
    <div className="flex-1 h-px bg-border" />
  </div>
);
